import { Component, HostListener, AfterViewInit, AfterViewChecked, OnDestroy, ViewEncapsulation, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { AjaxService } from '../../services/ajax.service';
import * as $ from 'jquery';
window['$'] = window['jQuery'] = $;
import { GameWindowService } from '../../services/gameWindow.services';
import { environment } from '../../../environments/environment';
import { Utility } from '../../shared/utility/utility';
import { EmitterService } from '../../services/emitter.service';


import { ChangeDetectorRef } from '@angular/core';
import { AppDetailsService } from '../../services/app-details.services';
import { FormBuilder } from '@angular/forms';
import { CustomValidators } from '../../shared/utility/custom-validator';
import { TranslateService } from "@ngx-translate/core";
import { FormValidationComponent } from '../../form-validation/form-validation.component';
import { CountryDataService } from '../../services/country.service';
import { map, takeUntil } from 'rxjs/operators';
import { UserDetailsService } from '../../services/user-details.service';
import { PnpZimplerService } from '../../services/pnp-zimpler.service';
import { Subject } from 'rxjs';
import * as _ from "underscore";
import { Location } from '@angular/common';
@Component({
  selector: 'app-gamingwindow',
  templateUrl: './gamingwindow.component.html',
  styleUrls: ['./gamingwindow.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GamingwindowComponent extends FormValidationComponent implements OnDestroy, AfterViewInit, AfterViewChecked, OnInit {
  windowHeight: number;
  aspectRatio: any;
  isLoggedIn: boolean;
  windowType;
  gameId;
  gameLaunchUrlPath;
  gameType:string='';
  hideSuccess;
  qDResponse;
  userCurrency;
  gamePathUrl;
  vendorSlug: string;
  langCode;
  countryCode;
  exclusionPasswordPage = false;
  swedishHeader: number = 0;
  extraWindowSpace = 134;
  game_notification = 50;
  serverError;
  viewPassword = false;
  prevUrl;
  landScapeMode;
  userCurrencySymbol;
  userTotalBalance;
  currentGameId = "";
  activeGameInfo:any={};
  websiteName = environment.website_name;
  websiteLogoExtension = environment.website_logo_extension;

  siteUrlPath: string = environment.siteUrl;
  webisteCode = environment.website_code;
  mediaPath = environment.mediaPath;
  
  isZimplerProfile: boolean = false;
  gameWindowWidth;

  suspendAccountForm = this.formBuilder.group({
    'expire': ['1', [this.CustomValidators.required]],
    'reason': ['Self Exclusion', [this.CustomValidators.required]],
    'password': ['', [this.CustomValidators.required]],
  });

  @Input()
  isGameminimized:boolean=false;
  isCountryAllowed: number;
  allGamesData;
  destroy$: Subject<boolean> = new Subject<boolean>();
  manageGameWindowWidth = false;

  @HostListener('window:resize') onResize() {
    this.resizeWindow();
    this.detectLandscape();
    this.gameScreen();
  }

  @HostListener('window:message', ['$event'])
  onMessage(e) {
    if(e["data"] === "pplive_enter_fs"){
      this.GoToFullScreen();
    }else if(e["data"] === "pplive_exit_fs"){
      this.GoOutFullscreen();
    }

  }

  constructor(
    private formBuilder: FormBuilder,
    private CustomValidators: CustomValidators,
    private emitterService: EmitterService,
    private router: Router,
    private utils: Utility,
    private gmService: GameWindowService,
    private activatedRoute: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private appDetailsService: AppDetailsService,
    private translationService: TranslateService,
    private ajaxService: AjaxService,
    private userDetailsService: UserDetailsService,
    private countryDataService: CountryDataService,
    private pnpService: PnpZimplerService,
    private location: Location
  ) {
    super(utils);

    this.isLoggedIn = this.utils.isUserLoggedIn();
    this.isGameminimized = this.utils.getIsGameWindowMinimized();

    this.emitterService.updateLoginStatus$.pipe(takeUntil(this.destroy$)).subscribe(loginStatus => {
      this.isLoggedIn = loginStatus;
      this.gameScreen();
      this.userCurrencySymbol = this.userDetailsService.getUserCurrencySymbol();
      this.userTotalBalance = this.userDetailsService.getUserTotalBalance();  
      this.completeZimplerForm();
    });

    // this.emitterService.loginComplete$.pipe(takeUntil(this.destroy$)).subscribe(message => {
    //   // this.gmService.switchInputStatus = true;
    //   this.gmService.loadGame('realgames', this.gameId, this.vendorSlug);
    // });

    // this.emitterService.gameLaunchEmitter$.pipe(takeUntil(this.destroy$)).subscribe(response => {
    //   this.gameOpen(response);
    // });

    this.activatedRoute.paramMap.pipe(map((params: ParamMap) => params.get('gameId'))).pipe(takeUntil(this.destroy$)).subscribe((gameId)=>{
      let launchedGamePath = gameId;
      let gameInfo = this.utils.getActiveGameInfo();
      let isGameToBeLauched = this.utils.getIsGametoBeLaunched();
      let activeGameId = (gameInfo && gameInfo.gameId && gameInfo.gameId !== undefined) ? gameInfo.gameId : null;
      let activeGameLaunchUrlPath = (gameInfo && gameInfo.gameLaunchUrlPath && gameInfo.gameLaunchUrlPath !== undefined) ? gameInfo.gameLaunchUrlPath : activeGameId;
      this.gamePathUrl = activeGameId ? this.gamePathUrl = environment.apiUrl + "/" + environment.gamePath + "/" + activeGameId + "/" + activeGameId + "-bg-image.jpg" : activeGameId;
      
      this.resizeWindow();
      this.detectLandscape();
      this.gameScreen();

      // set game data if launched from url only not from clickables
      //if we click on any route links code flow enters here and navigates to game page again to avoid it isGameToBeLauched boolean value used.
      if(isGameToBeLauched && launchedGamePath && activeGameLaunchUrlPath!==launchedGamePath && window.location.pathname.includes("gameplay")) {
        $("#gameIframeWrapper").removeClass('transparentBg');
        $("#gameIframeWrapper").html('');
        this.emitterService.broadCastGameWindowMinimized(false);
        this.checkGamesDataAvailability();
      }
      if(gameInfo && (gameInfo['gameId'] || gameInfo['gameLaunchUrlPath'])) {
        this.utils.checkGameDataToSetMetaData();
      }

    });

    this.emitterService.isGameWindowInitialized$.pipe(takeUntil(this.destroy$)).subscribe(response => {
      $("#gameIframeWrapper").removeClass('transparentBg');
      $("#gameIframeWrapper").html('');
      this.emitterService.broadCastGameWindowMinimized(false);
      this.initialization();
    });

    this.emitterService.updatedActiveGameInfo$.pipe(takeUntil(this.destroy$)).subscribe(updatedActiveGameInfo => {
      if(updatedActiveGameInfo) {
        let activeGameId = updatedActiveGameInfo.gameId;
        this.gamePathUrl = activeGameId ? this.gamePathUrl = environment.apiUrl + "/" + environment.gamePath + "/" + activeGameId + "/" + activeGameId + "-bg-image.jpg" : activeGameId;
      }
    });

    this.langCode = localStorage.getItem('langCode')
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
      this.langCode = langCode;
    });

    this.emitterService.isCountryAllowed$.pipe(takeUntil(this.destroy$)).subscribe(data=>{
      this.isCountryAllowed = data;
    })

    this.userDetailsService.userTotalBalanceUpdated$.pipe(takeUntil(this.destroy$)).subscribe((userTotalbalance)=>{
      this.userTotalBalance=userTotalbalance;
    });
  }

  ngOnInit(): void {
    this.updateGameWindowSize();
  }
  updateGameWindowSize(){
    let currentUrl = window.location.href; 
    if(environment.gameWindowAdjustableVendorList && environment.gameWindowAdjustableVendorList.length){
      environment.gameWindowAdjustableVendorList.forEach((vendor) =>{
        if(currentUrl.includes(vendor)){
          this.manageGameWindowWidth = true;
          return;  
        }
      })
    }
  }
  resizeWindow() {
    const ww = document.body.clientWidth;
    if (ww <= 1024) {
      this.windowType = "mobile";
      if(this.utils.getIsGameWindowMinimized()){
        this.takeToGamepage();
      }
    } else {
      this.windowType = "device";
    }
  }

  detectLandscape() {
    let ww = document.body.clientWidth;
    if (window.matchMedia("(orientation: landscape)").matches && ww <= 992 && this.isLoggedIn){
      this.landScapeMode = true;
    } else {
      this.landScapeMode = false;
    }
  }

  gameMiniWindow(){
    this.isGameminimized=true;
    this.utils.setIsGameWindowMinimized(true);
    this.emitterService.broadCastGameWindowMinimized(true);
    this.location.back();
  }

  GoToFullScreen(){
    let iframe = document.querySelector('#gameIframeWrapper iframe');;
    if (iframe) {
      if (iframe["requestFullscreen"]) {
        iframe["requestFullscreen"]();
      } else if (iframe["webkitRequestFullscreen"]) {
        iframe["webkitRequestFullscreen"]();
      } else if (iframe["mozRequestFullScreen"]) {
        iframe["mozRequestFullScreen"]();
      } else if (iframe["msRequestFullscreen"]) {
        iframe["msRequestFullscreen"]();
      }
    }
  }

  GoOutFullscreen() {
    document.exitFullscreen();
  }

  setGameData(){
    this.gameLaunchUrlPath = this.activatedRoute.snapshot.params['gameId'];
    this.gameId = this.allGamesData[this.gameLaunchUrlPath] ? this.allGamesData[this.gameLaunchUrlPath].gameCode : null;
    this.activeGameInfo.gameId = this.gameId;
    this.activeGameInfo.gameLaunchUrlPath = this.gameLaunchUrlPath;
    this.userDetailsService.gamePlayLaunchChecks(this.gameId, this.gameLaunchUrlPath);
  }

  checkGamesDataAvailability(){
    this.allGamesData = this.gmService.getMultiLingualGameObj();
    if (this.allGamesData && Object.keys(this.allGamesData).length > 0) {
      this.setGameData();
    } else if (this.allGamesData && Object.keys(this.allGamesData).length === 0) {
      this.gmService.getAllCasinoGames().pipe(takeUntil(this.destroy$)).subscribe(gamesData => {
        this.setGameData();
      });
    }
  }

  initialization() {
    this.isLoggedIn = this.utils.isUserLoggedIn();
    this.resizeWindow();
    this.detectLandscape();
    this.gameOpen();
    this.gameScreen();
    this.swedenRegulator();
    this.appDetailsService.deleteGameLauncherParams();
    this.completeZimplerForm()
    // On Refresh load Casino gameType
    Promise.resolve(this.appDetailsService.getBlockedCountries())
      .then(
        res => {
          if (res && res["countryCode"]) {
            this.countryCode = res["countryCode"];
          } else {
            this.countryCode = "-NA-";
          }
        },
        SystemError => { }
      )
  }

  completeZimplerForm() {
    if(this.isLoggedIn && this.userDetailsService.checkZimplerUpdateOpen()){
      this.emitterService.broadCastIsZimplerForm(true)
    }
  }

  loopCount = 0;
  gameOpen(response?) {
    this.allGamesData = this.gmService.getMultiLingualGameObj();
    let gameInfo = this.utils.getActiveGameInfo();
    if(gameInfo && gameInfo.gameId && gameInfo.gameLaunchUrlPath){
      this.lunchGameWithDetails(gameInfo);
    }else{
      if(this.loopCount < 3){
        this.loopCount++;
        let self = this;
      setTimeout(()=>{
        self.gameOpen();
      },2000)
      }
    }
    
  }

  lunchGameWithDetails(gameInfo){
    let gameIdForAspectRatio = gameInfo && gameInfo['gameLaunchUrlPath'];
    this.aspectRatio = this.allGamesData[gameIdForAspectRatio] ? this.allGamesData[gameIdForAspectRatio]['aspectRatio'] : null;

    if(gameInfo && (gameInfo['gameId'] || gameInfo['gameLaunchUrlPath'])) {
      this.utils.checkGameDataToSetMetaData();
    }

    // this.gamePathUrl = environment.siteUrl + "/" + environment.gamePath + "/" + this.gameId + "/" + this.gameId + "-bg-image.jpg"; 
    Promise.resolve(this.ajaxService.getLoginStatus()).then(data => {
      if (data && data["status"]) {
        this.gmService.loadGame("realgames", gameInfo.gameId, gameInfo.gameLaunchUrlPath);
      } else {
        this.gmService.loadGame("freegames", gameInfo.gameId, gameInfo.gameLaunchUrlPath);
      }
    });

    this.emitterService.broadCastIsGameLanuched(true);
  }

  ngAfterViewInit() {
    setTimeout(_ => {
      this.resizeWindow();
    });
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
    this.userCurrencySymbol = this.userDetailsService.getUserCurrencySymbol();
    this.userTotalBalance = this.userDetailsService.getUserTotalBalance();
    this.resizeWindow();
  }

  takeToGamepage(){
    this.isGameminimized=false;
    this.utils.setIsGameWindowMinimized(false);
    this.emitterService.broadCastGameWindowMinimized(false);
    let gameInfo=this.utils.getActiveGameInfo();

    if(gameInfo!==null){
      this.router.navigate([this.langCode + "/gameplay/" + gameInfo.gameLaunchUrlPath]);
    }
  }

  navigateTo(path) {
    if(path==='login' && this.emitterService.isCountryAllowed === 1) {
      this.pnpService.openZimplerLogin()
      return;
    }
    this.router.navigate([this.langCode + '/' + path]);
    this.goToTop();
  }

  goBackPage(): void {
    this.emitterService.broadCastGameWindowMinimized(false);
    this.emitterService.broadCastGameWindowClosed(true);
    if(!this.utils.getIsGameWindowMinimized()){
      this.location.back();
    }else{
      this.emitterService.broadCastIsGameLanuched(false);
    }
    this.utils.setIsGameWindowMinimized(false);
  }

  goBackToHome() {
    this.emitterService.broadCastGameWindowMinimized(false);
    this.activatedRoute.queryParams.subscribe(params => {
      this.prevUrl = params['prevUrl'];
    });
    
    if(this.prevUrl && this.prevUrl.indexOf("login") >= 0){
      this.router.navigate([this.langCode+'/']);
    }else if(this.prevUrl){
      this.router.navigate([this.prevUrl]);
    }else{
      // this._location.back();
      this.router.navigate([this.langCode])
    }
    //this.router.navigate([this.langCode])
  }

  goToTop() {
    try {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    } catch (e) {
      window.scrollTo(0, 0);
    }
  }

  open(modalId) {
    this.exclusionPasswordPage = false;
    this.utils.openModal(modalId);
  }

  close(modalId) {
    this.exclusionPasswordPage = false;
    this.utils.closeModal(modalId);
  }

  panicExclusion(buttonId) {
    let errorDiv = "#serverError-suspendAccount";
    this.utils.disableNewButton(buttonId);
    if (this.suspendAccountForm.valid) {
      let data = this.utils.formControlToParams(this.suspendAccountForm, {});
      Promise.resolve(this.ajaxService.suspendAccount(data))
        .then(susAccountData => {
          if (susAccountData && susAccountData["success"]) {
            this.utils.enableNewButton(buttonId, "Success", "Success", "Suspend");
            // this.isSuspendAccountModal = true;
            setTimeout(_ => {
              // this.pwdModl = false;
              // this.confpasswordModl = true;
              this.emitterService.broadcastlogoutComplete("userLoggedOff");
              this.utils.closeModal('suspendAccountModalInGame');
            }, 100)

          } else {
            this.utils.enableNewButton(buttonId, "Failed", "Failed", "Suspend");
            if (susAccountData["errors"]) {
              if (susAccountData["errors"]["password"]) {
                this.serverError = susAccountData["errors"]["password"];
              }
              else if (susAccountData["errors"]["message"]) {
                this.serverError = susAccountData["errors"]["message"];
              }
            }
            this.emitterService.broadcastserverError(this.serverError, this.router.url);
          }
        }, SystemError => {
          this.serverError = this.translationService.instant('errors.error');

          //  this.serverError = "Something went wrong. Please try again later.";
          this.utils.showError(errorDiv);
          this.utils.enableNewButton(buttonId, "Failed", "Failed", "Suspend");
          this.emitterService.broadcastserverError(this.serverError, this.router.url);
        });

    }
    else {
      this.utils.enableNewButton(buttonId, "Failed", "Failed", "Suspend");

      this.utils.validateAllFormFields(this.suspendAccountForm);
    }
  }

  confirmSusupend() {
    this.exclusionPasswordPage = true;
  }

  swedenRegulator() {
    Promise.resolve(this.countryDataService.getCountriesDetails()).then((countries): any => {
      if (countries['countryCode'] === 'SE') {
        // this.swedishHeader = 40;
        this.swedishHeader = 0;
        this.gameScreen();
      }
    })
  }

  gameScreen() {
    if (this.isLoggedIn) {
      this.windowHeight = document.body.clientHeight - (this.extraWindowSpace + this.swedishHeader);
    } else {
      this.windowHeight = document.body.clientHeight - ((this.extraWindowSpace + this.game_notification) + this.swedishHeader);
    }
    this.gameWindowWidth = this.windowHeight * ((this.aspectRatio === 2) ? 1.33 : 1.78);
  }

  goToRegister() {
    if(this.userDetailsService.checkZimplerDepositOpen()) {
      this.pnpService.openZimplerDeposit()
    } else {
      this.appDetailsService.setGameLauncherParams(this.gameId, this.gameLaunchUrlPath);
      this.emitterService.broadCastXSaleRegistration(true);
    }
  }

  openDeposit() {
    if(this.userDetailsService.checkZimplerUpdateOpen()) {
      this.emitterService.broadCastIsZimplerForm(true)
    } else if((this.userDetailsService.checkZimplerDepositOpen())) {
      this.pnpService.openZimplerDeposit()
    } else if(!this.userDetailsService.checkIsPNPUser()){
      this.emitterService.broadcastModalState({ name: "paymentModal", state: "open", cashierType: "deposit" });
    }
    // this.emitterService.broadcastModalState({name:"paymentModal",state:"open",cashierType:"deposit"});
  }

  openSearch() {
    this.utils.showSearchBar();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
